<script setup lang="ts">
import { PhxsgLoaderProps, PhxsgLoader as PhxsgCoreLoader } from '@sg-core/src/View/Components/Atoms/Loader';
import './loader.css';

defineProps<PhxsgLoaderProps>();
</script>

<template>
  <PhxsgCoreLoader v-bind="$props" type="line" />
</template>
